import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../../../atoms/DependencyHelper";
import formStyles from "../../NewLineForms.module.scss";
import DropDown from "../../dropDown/DropDown";
import DebicheckMandate from "../../../../organisms/debicheckMandate/DebicheckMandate";

const DebitDetailsForm = ({
  formName,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  onChangeHandler,
  bankList,
  accountTypeList,
  debitOrderDateList,
  onResetHandler,
  isDisplayBranchInfo,
  onBlurHandler,
  onFocusHandler,
  multicartFlag
}) => {
  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };

  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  const handleFocus = (event) => {
    onFocusHandler(event, formName);
  };

  return (
    <CustomContainer className={`${formStyles["main-container"]}`}>
      <Form.Row className={`${formStyles["main-row"]}`}>
        <>
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormdd101`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormdd101-label`}
            >
              Bank
            </Form.Label>
            <DropDown
              formName={formName}
              name="bank"
              label="Bank"
              data={bankList}
              required={true}
              handleSelect={onChangeHandler}
              handleBlur={handleBlur}
              selectedId={fieldValues["bank"]}
              customId={`validationFormdd101`}
              handleReset={onResetHandler}
              resetRequired={true}
              fieldError={fieldErrors["bank"]}
            />
            {fieldErrors["bank"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["bank"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          {isDisplayBranchInfo && (
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormdd102`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormdd102-label`}
              >
                Branch name
              </Form.Label>
              <Form.Control
                type="text"
                name="branchName"
                value={fieldValues["branchName"]}
                placeholder="Add branch name"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={fieldErrors["branchName"]}
                className={
                  fieldErrors["branchName"] ? formStyles["invalid"] : ""
                }
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["branchName"]}
              </Form.Control.Feedback>
            </Form.Group>
          )}

          {isDisplayBranchInfo && (
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
              controlId={`validationFormdd103`}
            >
              <Form.Label
                className={formStyles["form-label"]}
                id={`validationFormdd103-label`}
              >
                Branch code
              </Form.Label>
              <Form.Control
                type="text"
                name="branchCode"
                value={fieldValues["branchCode"]}
                placeholder="Add branch code"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={fieldErrors["branchCode"]}
                className={
                  fieldErrors["branchCode"] ? formStyles["invalid"] : ""
                }
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["branchCode"]}
              </Form.Control.Feedback>
            </Form.Group>
          )}
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormdd104`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormdd104-label`}
            >
              Account Type
            </Form.Label>
            <DropDown
              formName={formName}
              name="accountType"
              label="Account type"
              data={accountTypeList}
              required={true}
              handleSelect={onChangeHandler}
              handleBlur={handleBlur}
              selectedId={fieldValues["accountType"]}
              customId={`validationFormdd104`}
              handleReset={onResetHandler}
              resetRequired={true}
              fieldError={fieldErrors["accountType"]}
            />
            {fieldErrors["accountType"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["accountType"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormdd105`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormdd105-label`}
            >
              Account number
            </Form.Label>
            <Form.Control
              type="text"
              name="accountNumber"
              value={fieldValues["accountNumber"]}
              placeholder="Add account number"
              required
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={fieldErrors["accountNumber"]}
              className={
                fieldErrors["accountNumber"] ? formStyles["invalid"] : ""
              }
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["accountNumber"]}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Row className={formStyles["form-row"]}>
            <Form.Label
              className={`${formStyles["form-label"]} d-none d-md-block d-lg-block`}
              id={`validationFormdd106-label`}
            >
              Account holder initials & surname
            </Form.Label>

            <Form.Group
              as={Col}
              sm="5"
              md="5"
              className={`${formStyles["form-group"]}`}
              controlId={`validationFormdd107`}
            >
              <Form.Label
                className={`d-block d-sm-none ${formStyles["form-label"]} `}
                id={`validationFormdd107-label`}
              >
                Account holder initials
              </Form.Label>
              <Form.Control
                type="text"
                name="initials"
                value={fieldValues["initials"]}
                placeholder="Add initials"
                required
                onBlur={handleBlur}
                onChange={handleChange}
                isInvalid={fieldErrors["initials"]}
                className={fieldErrors["initials"] ? formStyles["invalid"] : ""}
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["initials"]}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group
              as={Col}
              sm="7"
              md="7"
              className={`${formStyles["form-group"]}`}
              controlId={`validationFormdd108`}
            >
              <Form.Label
                className={`d-block d-sm-none ${formStyles["form-label"]}`}
                id={`validationFormdd108-label`}
              >
                Account holder surname
              </Form.Label>
              <Form.Control
                type="text"
                name="surname"
                value={fieldValues["surname"]}
                placeholder="Add your surname"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={fieldErrors["surname"]}
                className={fieldErrors["surname"] ? formStyles["invalid"] : ""}
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {fieldErrorsMessage["surname"]}
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          
          <Form.Row className={formStyles["form-row"]}>
            <Form.Label
              className={`${formStyles["form-label"]}`}
              id={`validationFormdd110-label`}
            >
              How long have you had this account?
            </Form.Label>

            <Form.Group
              as={Col}
              className={`${formStyles["form-group"]}`}
              controlId={`validationFormdd1101`}
            >
              <Form.Control
                type="text"
                name="ageOfAccountYears"
                value={fieldValues["ageOfAccountYears"]}
                placeholder="Years"
                required
                maxLength="2"
                onBlur={handleBlur}
                onChange={handleChange}
                onFocus={handleFocus}
                isInvalid={fieldErrors["duration"]}
                className={fieldErrors["duration"] ? formStyles["invalid"] : ""}
              />
            </Form.Group>

            <Form.Group
              as={Col}
              className={`${formStyles["form-group"]}`}
              controlId={`validationFormdd1102`}
            >
              <Form.Control
                type="text"
                name="ageOfAccountMonths"
                value={fieldValues["ageOfAccountMonths"]}
                placeholder="Months"
                required
                maxLength="2"
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
                isInvalid={fieldErrors["duration"]}
                className={fieldErrors["duration"] ? formStyles["invalid"] : ""}
              />
            </Form.Group>
            {fieldErrors["duration"] && (
              <Form.Group
                as={Col}
                sm="12"
                md="12"
                className={`${formStyles["form-group"]} p-0`}
                controlId={`validationFormha108021`}
              >
                <Form.Control.Feedback
                  type="invalid"
                  className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
                >
                  {fieldErrorsMessage["duration"]}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </Form.Row>

          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormdd111`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormdd111-label`}
            >
              Preferred debit order date
            </Form.Label>
            <DropDown
              formName={formName}
              name="debitOrderDate"
              label="Debit order date"
              data={debitOrderDateList}
              required={true}
              handleSelect={onChangeHandler}
              handleBlur={handleBlur}
              selectedId={fieldValues["debitOrderDate"]}
              customId={`validationFormdd111`}
              handleReset={onResetHandler}
              resetRequired={true}
              fieldError={fieldErrors["debitOrderDate"]}
            />
            {fieldErrors["debitOrderDate"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["debitOrderDate"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </>
      </Form.Row>

      <DebicheckMandate
        isCheckedState={fieldValues["debiCheckFlag"] === "N" ? false : true}
        onChangeHandler={handleChange}
        multicartFlag={multicartFlag}
      ></DebicheckMandate>
    </CustomContainer>
  );
};

DebitDetailsForm.propTypes = {
  formName: PropTypes.string,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  onChangeHandler: PropTypes.func,
};

DebitDetailsForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
};

export default DebitDetailsForm;
